import { TicketsRoutingModule } from './tickets.routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedAppModule } from '../app.module.shared';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TicketDashboardComponent } from './ticket.dashboard/ticket.dashboard.component'

@NgModule({
  declarations: [
        TicketDashboardComponent
    ],
    entryComponents: [
    ],
    imports: [
        CommonModule,
        SharedAppModule,
        ReactiveFormsModule,
        FormsModule,
        TicketsRoutingModule,
    ]
})
export class TicketsModule { }
